type Context = 'api';

type Section = 'create' | 'fetch' | 'delete';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  create: 'api-create',
  fetch: 'api-fetch',
  delete: 'api-delete',
};
